import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { LagermalBasDataDTO } from "~app/common/models/lagermal/LagermalBasDataDTO";
import { LagermalDTO, LagermalResponseDTO } from "~app/common/models/lagermal/LagermalResponseDTO";
import { ApiClientService } from "~app/common/services/api-client.service";

@Injectable({
    providedIn: "root"
})
export class HanteraLagermalService {
    private readonly apiClient = inject(ApiClientService);

    getLagermalBasData(): Observable<LagermalBasDataDTO> {
        return this.apiClient.get("Kundorder/GetLagermalBasData", true);
    }

    getLagermal(moId: number, poId: number, period: Date): Observable<LagermalResponseDTO> {
        return this.apiClient.post("Kundorder/GetLagermalByYear", {
            marknadsomradeId: moId,
            produktionsomradeId: poId,
            period: period
        }, true);
    }

    saveLagermal(moId: number, poId: number, lagermal: LagermalDTO[], period: Date): Observable<LagermalResponseDTO> {
        return this.apiClient.post("Kundorder/SaveLagermal", {
            marknadsomradeId: moId,
            produktionsomradeId: poId,
            lagermal: lagermal,
            period: period
        }, true);
    }
}
